import { RiskAssesmentViewModel } from "./riskAssesmentViewModel";

export class RiskAssesmentDetailsViewModel extends RiskAssesmentViewModel {

}
